import {FORMS_TEMPLATE_IDS} from '../../constants';
import {FormViewer} from '@wix/form-viewer/widget';
import React, {useEffect} from 'react';
import {useICUI18n} from '../../Hooks/useICUI18n';
import {FormOverrides} from '@wix/form-viewer';
import {useControllerProps} from '../../Widget/ControllerContext';
import {usePanorama, useExperiments} from '@wix/yoshi-flow-editor';
import {getCustomerDetailsFormOverrides} from './CustomerDetailsForm.utils';
import {CustomerDetailsFormSection} from '../../../../types/checkoutApp.types';
import {classes} from './CustomerDetailsForm.st.css';
import {FormProps, getCountryCode} from '../form.utils';
import {SPECS} from '../../../../common/constants';

export interface CustomerDetailsFormProps extends FormProps {
  formSections?: CustomerDetailsFormSection[];
  dataHook?: string;
}

const CustomerDetailsFormInternal = ({
  formRef,
  formValues,
  setFormValues,
  formErrors,
  setFormErrors,
  formSections,
  dataHook,
}: CustomerDetailsFormProps) => {
  const i18n = useICUI18n();
  const panorama = usePanorama();
  const {experiments} = useExperiments();
  const country = getCountryCode(formValues);
  const {
    checkoutSettingsStore: {checkoutSettings},
    checkoutStore: {isShippingFlow, isFastFlow},
    memberStore: {isMember, currentUserEmail},
    formsStore: {checkoutExcludeGoogleAutoComplete, doesFormHaveMultilineAddress},
  } = useControllerProps();
  const overrideDeliveryCountriesOnlyOnShippingFlow = experiments.enabled(
    SPECS.overrideDeliveryCountriesOnlyOnShippingFlow
  );

  useEffect(() => {
    if (isMember) {
      formValues.email = currentUserEmail;
    }
  });

  return (
    <div className={classes.root} data-hook={dataHook}>
      <FormViewer
        i18n={i18n}
        panorama={panorama}
        ref={formRef}
        formId={FORMS_TEMPLATE_IDS.CUSTOMER_DETAILS}
        values={formValues}
        errors={formErrors}
        onChange={setFormValues}
        overrides={
          getCustomerDetailsFormOverrides({
            checkoutSettings,
            excludeGoogleAutoComplete: checkoutExcludeGoogleAutoComplete,
            country,
            isShippingFlow,
            overrideDeliveryCountriesOnlyOnShippingFlow,
            isMember,
            formSections,
            isFastFlow,
            doesFormHaveMultilineAddress,
          }) as FormOverrides
        }
        onValidate={setFormErrors}
      />
    </div>
  );
};

export const CustomerDetailsForm = React.memo(CustomerDetailsFormInternal);
